<template>
    <kt-panel v-if="status === 'success-psp-report'">
        <div class="card-body">
            <kt-form-section >
                <kt-form-row>
                    <kt-col xs="12" sm="6" md="3">
                        <kt-form-group>
                            <kt-form-label for="referenceId">
                                {{ $t('transactions-report.referenceCode') }}
                            </kt-form-label>
                            <kt-form-control
                                    ref="referenceCode"
                                    name="referenceCode"
                                    id="referenceCode"
                                    v-model="query.referenceCode"
                                    dir="ltr"
                            />
                        </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="3">
                        <kt-form-group>
                            <kt-form-label for="switchTraceNo">
                                {{ $t('transactions-report.traceCode') }}
                            </kt-form-label>
                            <kt-form-control
                                    ref="traceCode"
                                    name="traceCode"
                                    id="traceCode"
                                    v-model="query.traceCode"
                                    dir="ltr"
                            />
                        </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="3">
                        <kt-form-group>
                            <kt-form-label for="minAmount">
                                {{ $t('transactions-report.minAmount') }}
                            </kt-form-label>
                            <kt-form-control
                                    ref="minAmount"
                                    dir="ltr"
                                    name="minAmount"
                                    id="minAmount"
                                    v-model="query.minAmount"
                            />
                        </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="3">
                        <kt-form-group>
                            <kt-form-label for="maxAmount">
                                {{ $t('transactions-report.maxAmount') }}
                            </kt-form-label>
                            <kt-form-control
                                    ref="maxAmount"
                                    dir="ltr"
                                    name="maxAmount"
                                    id="maxAmount"
                                    v-model="query.maxAmount"
                            />
                        </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="3">
                        <kt-form-group>
                            <kt-form-label>
                                {{ $t('label.terminal_title') }}
                            </kt-form-label>
                            <select
                                    class="form-control kt-selectpicker"
                                    id="terminal_title"
                                    name="terminal_title"
                                    v-model="query.shop_id"
                            >
                                <option>{{ $t('selectpicker.nothing') }}</option>
                                <option
                                        v-for="(shop, index) in subsetShops"
                                        :key="index"
                                        :value="shop.shop_id"
                                >
                                    {{shop.shop_name}}
                                </option>
                            </select>
                        </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="3">
                        <kt-form-group id="card_number">
                            <kt-form-label for="card_number">
                                {{ $t('label.card_number') }}
                            </kt-form-label>
                            <kt-form-control
                                    ref="card_number"
                                    name="card_number"
                                    id="card_number_input"
                                    style="direction:ltr"
                                    v-model="query.card_number"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="3">
                        <kt-form-group>
                            <kt-form-label for="from_date">
                                {{ $t('label.from_date') }}
                            </kt-form-label>
                            <button id="reset_from_date"
                                    @click="clearFromDate"
                                    class="btn btn-label-danger trash-btn"
                            >
                                <i class="la la-trash-o"></i>
                            </button>
                            <datePicker
                                    color="#00c1a4"
                                    format="YYYY-MM-DD HH:mm:ss"
                                    display-format="dddd jDD jMMMM jYYYY HH:mm"
                                    input-class="form-control"
                                    id="from_date"
                                    name= "from_date"
                                    v-model="query.from_date"
                                    type="datetime"/>
                        </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="3">
                        <kt-form-group>
                            <kt-form-label for="to_date">
                                {{ $t('label.to_date') }}
                            </kt-form-label>
                            <button id="reset_to_date"
                                    @click="clearToDate"
                                    class="btn btn-label-danger trash-btn"
                            >
                                <i class="la la-trash-o"></i>
                            </button>
                            <datePicker
                                    color="#00c1a4"
                                    format="YYYY-MM-DD HH:mm:ss"
                                    display-format="dddd jDD jMMMM jYYYY HH:mm"
                                    input-class="form-control"
                                    id="to_date"
                                    name= "to_date"
                                    v-model="query.to_date"
                                    type="datetime"
                            />
                        </kt-form-group>
                    </kt-col>
                </kt-form-row>
            </kt-form-section>
            <kt-form-section>
                <kt-row>
                    <kt-col xs="12" sm="6" md="6">
                        <button class="btn btn-success btn-wide" @click="action($event, query)">
                            {{ $t('transactions-report.send-request') }}
                        </button>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="6">
                        <button
                                class="btn btn-success btn-wide float-right"
                                size="md"
                                type="button"
                                id="export_psp_transations_btn"
                                @click="exportExcel($event, query)"
                        >
                            {{ $t('btn.export_transaction_to_excel') }}
                        </button>
                    </kt-col>
                </kt-row>
            </kt-form-section>
        </div>
    </kt-panel>
</template>

<script>

    import $ from "jquery";
    import { i18n } from '@/plugins/i18n'
    import {mapGetters} from "vuex";
    import Inputmask from 'inputmask'

    export default {
        props: {
            action: {
                default: function(e, query) {},
                required: true,
            },
            exportExcel: {
                default: function(e, query) {},
                required: true,
            }
        },
        computed: {
            ...mapGetters('marketing', [
                'subsetShops',
                'status'
            ]),
        },
        mounted() {
            this.afterDispatch()
        },
        methods: {
            clearFromDate() {
                if(this.query.from_date) {
                    this.query.from_date = null
                }
            },
            clearToDate() {
                if(this.query.to_date) {
                    this.query.to_date = null
                }
            },
            afterDispatch() {
                setTimeout(function () {
                    $('.kt-selectpicker').selectpicker({
                        size: 4,
                        liveSearch: true,
                        noneResultsText: i18n.t('selectpicker.none_result'),
                        selectAllText: i18n.t('selectpicker.select_all'),
                        noneSelectedText: i18n.t('selectpicker.nothing_selected')
                    })
                }, 5000)
                setTimeout( function () {
                    Inputmask("9999-9999-9999-9999").mask(document.querySelectorAll('#card_number_input'))
                }, 6000)

            },
        },
        data() {
            return {
                query: {}
            }
        }
    }
</script>

<style>

</style>